import {parseParams} from '@wix/music-shared/dist/src/utils/url';

export function getIsTestMode() {
  return parseParams().test === 'true';
}
